// Geteiltes Karussell fuer alle [data-carousel]-Bloecke: Mediathek-Uebersicht,
// Mediathek-Teaser-Reihe und Pressefotos-Reihen.
export default function initCarousel(el) {
  const track = el.querySelector('[data-carousel-track]');
  const prevBtn = el.querySelector('[data-carousel-prev]');
  const nextBtn = el.querySelector('[data-carousel-next]');

  if (!track) return;

  // Scroll-Positionen, an denen jeweils eine Karte buendig links steht.
  // Basis ist die erste Karte, damit das Padding des Tracks rausgerechnet ist
  // und die erste Position wirklich 0 ist.
  function cardPositions() {
    const cards = Array.from(track.children);
    if (!cards.length) return [0];
    const trackLeft = track.getBoundingClientRect().left;
    const edges = cards.map(card =>
      Math.round(card.getBoundingClientRect().left - trackLeft + track.scrollLeft)
    );
    const base = edges[0];
    return edges.map(edge => edge - base);
  }

  // Weiterhin knapp eine Trackbreite pro Klick, aber auf die naechste
  // Kartenkante gerundet. Vorher landete der feste Schritt mitten in einer
  // Karte, und scroll-snap zog die Animation ruckartig auf den Snap-Punkt.
  function step(direction) {
    const max = Math.max(0, track.scrollWidth - track.clientWidth);
    const wanted = track.scrollLeft + direction * Math.round(track.clientWidth * 0.75);
    const positions = cardPositions();

    let target = positions.reduce(
      (best, pos) => (Math.abs(pos - wanted) < Math.abs(best - wanted) ? pos : best),
      positions[0]
    );

    // Karte breiter als der Track: die naechstgelegene Kante kann die aktuelle
    // sein — dann waere der Klick wirkungslos. In dem Fall frei scrollen.
    if (Math.abs(target - track.scrollLeft) < 2) target = wanted;

    track.scrollTo({ left: Math.min(Math.max(target, 0), max), behavior: 'smooth' });
  }

  function updateArrows() {
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    if (prevBtn) prevBtn.hidden = atStart;
    if (nextBtn) nextBtn.hidden = atEnd;
  }

  if (prevBtn) prevBtn.addEventListener('click', () => step(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => step(1));

  track.addEventListener('scroll', updateArrows, { passive: true });
  updateArrows();
}
